import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const Gallery = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const images = [
    {
      url: '/images/gallery-1.png',
      alt: 'Luxury Lounge Seating Area',
      span: 'md:col-span-2 md:row-span-2',
    },
    {
      url: '/images/gallery-2.png',
      alt: 'Canteen & Dining Area',
      span: 'md:col-span-1 md:row-span-1',
    },
    {
      url: '/images/gallery-3.png',
      alt: 'Premium Seating Lounge',
      span: 'md:col-span-1 md:row-span-1',
    },
    {
      url: '/images/gallery-4.png',
      alt: 'Elite Ambience',
      span: 'md:col-span-2 md:row-span-1',
    },
  ];

  return (
    <section
      id="gallery"
      ref={ref}
      className="py-20 md:py-32 bg-black"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="font-cinzel text-4xl md:text-5xl font-semibold text-gold mb-4 tracking-wide"
            data-testid="gallery-title"
          >
            The Arena
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto"></div>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[300px]">
          {images.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`gallery-item relative overflow-hidden group rounded-sm border border-neutral-800 ${image.span}`}
              data-testid={`gallery-item-${index}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
              <div className="image-overlay"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
